export const MARKETPLACE_CART_STORAGE_KEY = "petaar_marketplace_cart_v1";

const sanitizeCartItem = (item = {}) => {
  const productId = String(item.productId || "").trim();
  if (!productId) return null;
  return {
    productId,
    title: String(item.title || "Product"),
    category: String(item.category || ""),
    imageUrl: String(item.imageUrl || ""),
    price: Number(item.price || 0),
    qty: Math.max(1, Number(item.qty) || 1),
    providerId: String(item.providerId || ""),
    providerEmail: String(item.providerEmail || ""),
  };
};

export function readMarketplaceCartItems() {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(MARKETPLACE_CART_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.map(sanitizeCartItem).filter(Boolean);
  } catch (_) {
    return [];
  }
}

export function writeMarketplaceCartItems(items = []) {
  if (typeof window === "undefined") return;
  try {
    const sanitized = Array.isArray(items) ? items.map(sanitizeCartItem).filter(Boolean) : [];
    window.localStorage.setItem(MARKETPLACE_CART_STORAGE_KEY, JSON.stringify(sanitized));
  } catch (_) {}
}

